import {
	TextField,
	Button,
	Dialog,
	DialogContent,
	DialogActions,
	Alert,
	CircularProgress,
	Backdrop,
	IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { ApplyLabsCoupon } from "../../services/wapi";

export const LabsCoupon = ({ visible, setVisibility, onSuccess, data, selectedWallet }) => {
	const [isLoading, setLoading] = useState(false);
	const [couponCode, setCouponCode] = useState("");
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState("");

	const applyCoupon = async () => {
		try {
			setLoading(true);
			setShowAlert(false);
			const response = await ApplyLabsCoupon(
				{
					couponCode: couponCode,
					paymentMethod: selectedWallet?.paymentMethod || "PG",
				},
				data.shortToken,
			);

			if (!response.isSuccess) throw new Error(response?.message);

			response.response.couponCode = couponCode;

			onSuccess(response.response);
			setVisibility(false);
		} catch (ex) {
			setShowAlert(true);
			setAlertMessage(ex.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Backdrop open={isLoading} sx={{ zIndex: 99999 }}>
				<CircularProgress />
			</Backdrop>
			<Dialog
				open={visible}
				onClose={() => setVisibility(false)}
				className="bottom-sheet-modal"
			>
				<DialogContent style={{ paddingTop: "15px" }}>
					<TextField
						fullWidth
						variant="outlined"
						placeholder="Enter Coupon Code"
						value={couponCode}
						onChange={(e) => setCouponCode(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button
						fullWidth
						variant="contained"
						color="primary"
						onClick={applyCoupon}
					>
						APPLY
					</Button>
				</DialogActions>

				{!isLoading && showAlert && (
					<Alert
						severity="error"
						sx={{ marginTop: "20px" }}
						action={
							<IconButton
								aria-label="close"
								color="inherit"
								size="small"
								onClick={() => setShowAlert(false)}
							>
								<CloseIcon fontSize="inherit" />
							</IconButton>
						}
					>
						{ alertMessage }
					</Alert>
				)}
			</Dialog>
		</>
	);
};
